import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LaborManagement_ds_get_work_class_assignment_by_workClassId_userIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { workClassId: number, userId: string }): 
  Promise<{ result: { WorkClassId?: number, UserId?: string } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.workClassId)) {
      missingRequiredInParams.push('\'workClassId\'');
    }
    if (isNil(inParams.userId)) {
      missingRequiredInParams.push('\'userId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_get_work_class_assignment_by_workClassId_userId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      workClassId: number, userId: string    }) {
        if(isNil(inParams.workClassId)) {
          return true; 
        }
        if(isNil(inParams.userId)) {
          return true; 
        }
      return false;
    }
}
